export const loadImage = (src?: string | null, timeout?: number) =>
  new Promise<HTMLImageElement>((resolve, reject) => {
    if (!src) {
      reject();
      return;
    }
    let time: any;
    if (timeout) {
      time = setTimeout(() => {
        reject(
          new Error(
            `L'image n'a pas chargé dans les temps (${timeout / 1000}s)`,
          ),
        );
      }, timeout);
    }
    const image = new Image();
    // eslint-disable-next-line immutable/no-mutation
    image.onload = () => {
      clearTimeout(time);
      resolve(image);
    };
    // eslint-disable-next-line immutable/no-mutation
    image.onerror = (message) => {
      clearTimeout(time);
      reject(
        new Error(
          typeof message === 'string'
            ? message
            : "Erreur lors du chargement de l'image",
        ),
      );
    };
    // eslint-disable-next-line immutable/no-mutation
    image.src = src;
  });
